<template>
  <div
    class="basic_wrap"
    style="overflow: hidden;"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('index.aboutUs') }}
      </div>
    </div>
    <div class="wrap_box">
      <router-link
        v-for="(v,k) in data.list"
        :key="k"
        :to="'about/' + v.id"
        class="item"
      >
        {{ v['title_'+lang] }}
      </router-link>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "Login",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_icon_type: 'about',
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/about').then((r) => {
					this.data = r.data;
				});
			},
		}
	};
</script>

<style lang="less" scoped>
    .red_top_bg{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
	
	.wrap_box{
		margin: 66px 14px 18px;
		padding: 0 14px;
		border: 1px solid rgba(190, 139, 52, .46);
		border-radius: 14px;
		background: #fffdf8;
		box-shadow: 0 10px 24px rgba(125, 82, 35, .08);
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			height: 58px;
			width: 100%;
			padding: 0;
			border-bottom: 1px solid rgba(190, 139, 52, .22);
			font-size: 14px;
			color: #63352c;
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}
	.basic_wrap { min-height: 100vh; padding-bottom: calc(24px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); }.red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #873126; }
</style>
